import { DynamicEnvService } from '@myre/ui-domain-http';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { environment } from 'environments/environment';
import { version } from 'environments/version';

import { APP_ROUTES } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { provideCoreConfig } from './app/core/core.module';

if (environment.production) {
  enableProdMode();
}

DynamicEnvService.initializeEnvironment(version, version.myreSentryProjectName);

bootstrapApplication(AppComponent, {
  providers: [provideCoreConfig(), provideRouter(APP_ROUTES)],
})
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
